module.exports = __webpack_public_path__ + "img/compare.232cedb1.svg";